import type { RefObject } from 'react';
import { useTranslation } from 'react-i18next';

interface NameFieldsProps {
  variant: 'desktop' | 'mobile';
  firstName: string;
  lastName: string;
  onFirstNameChange: (value: string) => void;
  onLastNameChange: (value: string) => void;
  firstNameRef: RefObject<HTMLInputElement | null>;
  disabled?: boolean;
}

const NameFields = ({
  variant,
  firstName,
  lastName,
  onFirstNameChange,
  onLastNameChange,
  firstNameRef,
  disabled,
}: NameFieldsProps) => {
  const { t } = useTranslation();
  const isDesktop = variant === 'desktop';
  const idSuffix = isDesktop ? '' : '-mobile';
  const labelClassName = `mb-1.5 block font-body font-medium text-foreground-primary ${
    isDesktop ? 'text-sm' : 'text-[13px]'
  }`;
  const inputClassName = `w-full appearance-none rounded-lg border border-border-subtle bg-surface-primary px-4 py-3 font-body text-sm text-foreground-primary outline-none transition-colors placeholder:text-foreground-tertiary focus:border-accent-primary${
    isDesktop ? ' disabled:cursor-not-allowed disabled:opacity-50' : ''
  }`;

  return (
    <div className={isDesktop ? 'flex gap-4' : 'flex flex-col gap-3'}>
      <div className={isDesktop ? 'flex-1' : undefined}>
        <label htmlFor={`firstName${idSuffix}`} className={labelClassName}>
          {t('chat.nameModal.firstName')}
        </label>
        <input
          id={`firstName${idSuffix}`}
          ref={firstNameRef}
          type="text"
          value={firstName}
          onChange={(e) => onFirstNameChange(e.target.value)}
          placeholder={t('chat.nameModal.firstNamePlaceholder')}
          className={inputClassName}
          disabled={disabled}
        />
      </div>
      <div className={isDesktop ? 'flex-1' : undefined}>
        <label htmlFor={`lastName${idSuffix}`} className={labelClassName}>
          {t('chat.nameModal.lastName')}
        </label>
        <input
          id={`lastName${idSuffix}`}
          type="text"
          value={lastName}
          onChange={(e) => onLastNameChange(e.target.value)}
          placeholder={t('chat.nameModal.lastNamePlaceholder')}
          className={inputClassName}
          disabled={disabled}
        />
      </div>
    </div>
  );
};

export default NameFields;
